export class NC
{
    id: number;
    user: number;
    ticket: number; 
    content: string;
    postedon : Date; 
}